/* =============================================================
   D'Avila — Load more na pagina /search
   Substitui paginacao numerica por botao "Ver mais produtos" via AJAX.
   Fetch da proxima pagina, extrai os <li>s do grid da resposta e
   appenda no grid atual. Atualiza URL do botao pra proxima pagina
   (ou esconde se acabou).
   ============================================================= */
(function () {
  'use strict';

  var GRID_SELECTOR = '[data-davila-load-more-grid]';
  var BTN_SELECTOR = '[data-davila-load-more-btn]';
  var STATUS_SELECTOR = '[data-davila-load-more-status]';
  var WRAPPER_SELECTOR = '[data-davila-load-more]';

  function init() {
    var btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;
    if (btn.dataset.davilaBound === '1') return;
    btn.dataset.davilaBound = '1';

    // Click manual (fallback + acessibilidade)
    btn.addEventListener('click', function () { loadNext(btn); });

    // Auto-load quando botao aparece na viewport (vitrine infinita)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !btn.disabled && btn.getAttribute('data-next-url')) {
            loadNext(btn);
          }
        });
      }, { rootMargin: '400px 0px' }); // dispara 400px antes do botao aparecer
      io.observe(btn);
      // Re-observa apos load (o botao muda de data-next-url mas continua o mesmo node)
    }
  }

  function loadNext(btn) {
    var nextUrl = btn.getAttribute('data-next-url');
    if (!nextUrl) return;

    var grid = document.querySelector(GRID_SELECTOR);
    var status = document.querySelector(STATUS_SELECTOR);
    if (!grid) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (status) status.hidden = false;

    fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector(GRID_SELECTOR);
        var nextBtn = doc.querySelector(BTN_SELECTOR);

        if (nextGrid) {
          // Appenda todos os <li>s novos preservando animacao de fade
          var items = Array.prototype.slice.call(nextGrid.children);
          items.forEach(function (li) {
            li.classList.add('davila-load-more__item-in');
            grid.appendChild(li);
          });
          // Trigger animacao no proximo frame
          requestAnimationFrame(function () {
            items.forEach(function (li) {
              li.classList.add('davila-load-more__item-shown');
            });
          });
        }

        if (nextBtn && nextBtn.getAttribute('data-next-url')) {
          // Ainda tem mais paginas — atualiza URL do botao
          btn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
          btn.disabled = false;
          btn.classList.remove('is-loading');
        } else {
          // Acabou — esconde botao
          btn.remove();
        }

        if (status) status.hidden = true;
      })
      .catch(function (err) {
        console.error('davila-load-more:', err);
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (status) {
          status.hidden = false;
          status.textContent = 'Erro ao carregar. Tente novamente.';
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
